// import React from "react";
// import { FaLeaf } from "react-icons/fa";
// import "./CommonTabs.css"
// const CommonTabs = ({  items }) => {
//   return (

//     <div className="common-tab">
//       <ul className="common-tab-list">
//         {items?.map((item, index) => (
//           <li key={index} className="common-tab-item">
//             <span className="icon"> <img src="/images/product/leaf.png" alt=""/></span>
//             <span>{item}</span>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default CommonTabs;

import React from "react";
import "./CommonTabs.css";

const CommonTabs = ({ productsdetailss, field }) => {
  return (
    <div className="common-tab">
      <ul className="common-tab-list">
        {productsdetailss?.map((item, index) => (
          <li key={index} className="common-tab-item">
            <span className="icon">
              <img src="/images/product/leaf.png" alt="" />
            </span>

            <span>{item?.[field]}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CommonTabs;
